import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDiscover$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDiscover extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'aebcdbfe0b0f6d61f4dbda348f7ef61918e4455f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a20c4c892c8ee5a439e9cf033ea8c19b6ef5a533', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd796e17cf1c8c7f724f422050ce266b1999be5e3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0m16.5 0a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0M9 9.25 7 14.7a.27.27 0 0 0 .34.34l5.46-1.91a.45.45 0 0 0 .27-.27L15 7.41a.26.26 0 0 0-.34-.34L9.22 9a.44.44 0 0 0-.22.25m.91 1.83c0 .646.524 1.17 1.17 1.17l-.08-.03a1.17 1.17 0 0 0 1.25-1.14 1.17 1.17 0 1 0-2.34 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-discover", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-discover"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-discover":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDiscover$1);
            }
            break;
    } });
}

const CosmosIconDiscover = CosmosIconDiscover$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDiscover, defineCustomElement };
